import { attr, hasMany } from 'spraypaint';
import ApplicationRecord from './ApplicationRecord';
import Availability from './Availability';

const Courier = ApplicationRecord.extend({
  attrs: {
    code: attr(),
    name: attr(),
    recipe_cutoff_hours_before_delivery_date: attr(),
    shop_cutoff_hours_before_delivery_date: attr(),
    availabilities: hasMany({ type: 'couriers-availabilities' }),
  },
  static: {
    endpoint: '/couriers',
    jsonapiType: 'couriers-couriers',
  },
});

export default Courier;
